import { observer, useLocalObservable } from "mobx-react"
import { Flex, Form, Typography } from "antd"

import { DomainsCollection } from "@src/pages/settingsDomain/classes/DomainsCollection"
import { DomainForm } from "@src/pages/settingsDomain/ui/DomainForm"
import { DomainsTable } from "@src/pages/settingsDomain/ui/DomainsTable"

export const SettingsDomainPage = observer(() => {
  const [form] = Form.useForm()

  const domains = useLocalObservable(() => new DomainsCollection())

  return (
    <Flex gap={32} vertical>
      <Typography.Text style={{ fontSize: 16 }}>
        When creating a new Checkout, you need to whitelist your website. <br />
        Please add your website domain.
      </Typography.Text>

      <DomainForm collection={domains} form={form} />

      {(!domains.isEmpty || domains.isLoading) && (
        <DomainsTable collection={domains} />
      )}
    </Flex>
  )
})
